import { render, staticRenderFns } from "./SectionLabel.vue?vue&type=template&id=67e7e7c4&scoped=true&"
var script = {}
import style0 from "./SectionLabel.vue?vue&type=style&index=0&id=67e7e7c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e7e7c4",
  null
  
)

export default component.exports